import React, { Component } from 'react';
import { Big3Common } from '../../js/IncludeManager'

/* 개발담당:양유빈
 * 화면기능:상품사진 포토 공통, 상세의 큰 이미지 사진, 리스트의 이미지사진(찜하기 기능 포함)
 * 세부설명:totalCount 속성이 있으면 상세에서 사용하는 큰 이미지, Bookmark=Uid/Goods_No가 있으면 찜하기 기능을 포함한 이미지
 * 필수옵션: Bookmark={{ Goods_No: list.goods_no, Uid: list.uid, Bookmark_Yn: list.bookmark_yn }}
 * 선택옵션: CallBack=부모페이지의 함수 호출, SimilarityYn="Y/N"
*/

export class GoodsPhoto extends Component {
    static displayName = GoodsPhoto.name;

    constructor(props) {
        super(props);
        this.state = {
            Bookmark_Yn: null,
            SelectYn: null,
        };
        this.handle_Click = this.handle_Click.bind(this);
        this.handle_Pressure = this.handle_Pressure.bind(this);
        //이미지 검색 기능 삭제
        //this.SimilarityYn = this.props.SimilarityYn || "N";
        this.SimilarityYn = "N";
        this.Edit_Yn = this.props.Edit_Yn || "N";
        this.TagID = "";
    }
    //초기화
    componentDidMount() {
        if (this.SimilarityYn === "Y") {
            this.handle_Pressure();
        }   
    }
    async handle_Click(event, Uid, Goods_No, Bookmark_Yn) {
       
        try {
            let Data = await Big3Common.Post("api/Common/Common/RegisterBokmkGoods",
                {
                    Goods_No: Goods_No,
                    Uid: Uid
                },
                true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let HeartYn = Bookmark_Yn === "Y" ? "N" : "Y";
                this.setState({ Bookmark_Yn: HeartYn });
                if (this.props.CallBack !== undefined) {
                    setTimeout(() => {
                        this.props.CallBack();
                    }, 300);
                }
            }
            else {
                console.log(Data.message);
            }
            
        }
        catch (e) {
            console.log("handle_Click: ", e)
        }

        event.preventDefault();
    }
    handle_Pressure() {
        //길게 눌러 이미지 검색 이벤트 실행 
        const img = document.getElementById(this.TagID);
        if (img !== null) {
            let pressTimer;
            const isTouchStartAdded = img.touchstartAdded || false;
            if (!isTouchStartAdded) {
                img.addEventListener('touchstart', function (e) {
                    pressTimer = setTimeout(function () {
                        var hiddenInput = document.getElementById('Similarity_Uid');
                        hiddenInput.value = img.id;
                        var event = new Event('click');
                        hiddenInput.dispatchEvent(event);
                    }, 500);
                }, false);

                img.addEventListener('touchend', function (e) {
                    clearTimeout(pressTimer); // 길게 누르기 이전에 터치가 끝나면 타이머 취소
                }, false);

                img.addEventListener('touchmove', function (e) {
                    clearTimeout(pressTimer); // 길게 누르기 중에 움직이면 타이머 취소
                }, false);

                img.touchstartAdded = true;
            }
            else {
                this.SimilarityYn = "N";
                this.forceUpdate();
            }
        }
        else {
            this.SimilarityYn = "N";
        }
    }
    renderBookMark(Uid, Goods_No, Bookmark_Yn) {
        let HeartYn = this.state.Bookmark_Yn === null ? Bookmark_Yn : this.state.Bookmark_Yn;
        let cssName = "heart";
        if (HeartYn === "Y") {
            cssName = "heart_checked";
        }

        if (this.Edit_Yn === "N") {
            return (
                <div className="bookmark" onClick={(e) => { e.stopPropagation(); e.preventDefault(); this.handle_Click(e, Uid, Goods_No, HeartYn); }}>
                    <div className={cssName} ></div>
                </div>
            )
        }
    }
    renderEditFolder(Uid, Goods_No) {
        const check = this.props.SelectList && this.props.SelectList.some(item => item.Goods_No === Goods_No && item.Uid === Uid);
        let cssName = "p_check";
        if (check) {
            cssName = "p_checked";
        }
        if (this.props.Edit_Yn === "Y") {
            return (
                <div className={cssName}>
                    <div className="check_box" ></div>
                </div>
            )
        }
        return false;
    }
    SoldOutrenderA() {
        if (this.props.SoldoutYn === undefined || this.props.SoldoutYn === "N") {
            return ("");
        }
        else {
            return (<div className="sold_out">sold out</div>)
        }
    }
    SoldOutrenderB() {
        if (this.props.SoldoutYn === undefined || this.props.SoldoutYn === "N") {
            return ("");
        }
        else {
            return (
                <div className="sold_out">
                    <p>sold out</p>
                </div>
            )
        }
    }
    AIimagerender() {
        if (this.SimilarityYn === "Y") {
            return (
                <div className="ai">AI</div>
            )
        }
        else {
            return (
                ""
            )
        }
        
    }
    render() {
        const VirtualRoot = Big3Common.WebConfig.GoodsImageVirtualPath();
        let className = "";
        let ImageSrc = "";
        let totalCount = ""; //이미지에 현재 총개수 (1/20) 표시
        let Uid = "";        //도매 uid
        let Goods_No = "";   //상품번호
        let Bookmark_Yn = "";//북마크 설정여부
        let BackGround = true;
        let Edit_Yn = "";
       /* const SimilarityYn = this.props.SimilarityYn || "N";*/
        if (this.props.className !== undefined && this.props.className !== null) {
            className = this.props.className;
        }
        if (this.props.ImageSrc !== undefined && this.props.ImageSrc !== null) {
            ImageSrc = this.props.ImageSrc;
        }
        if (this.props.TotalCount !== undefined && this.TotalCount !== null) {
            totalCount = this.props.TotalCount;
        }
        if (this.props.Bookmark !== undefined && this.props.Bookmark !== null) {
            Goods_No = this.props.Bookmark.Goods_No;
            Uid = this.props.Bookmark.Uid;
            Bookmark_Yn = this.props.Bookmark.Bookmark_Yn;
        } 
        if (this.props.BackGround !== undefined) {
            BackGround = this.props.BackGround;
        }
        if (this.props.Edit_Yn !== undefined && this.props.Bookmark !== null) {
            Edit_Yn = this.props.Edit_Yn
        }
        //유사도 검색 사용여부 설정
       /* this.SimilarityYn = SimilarityYn;*/
        this.TagID = `${Uid}_${Goods_No}`;
        if (Uid === "" || Goods_No === "") {
            //Uid와 Goods_No 값이 없으면 SimilarityYn="Y" 일지라도 유사도 검색을 하지 못함.
            this.SimilarityYn = "N";
            this.TagID = Big3Common.getGuid();
        }
        if (ImageSrc !== "" && totalCount !== "") {
            if (BackGround === true) {
                return (
                    <>
                        <div className={className} id={this.TagID} style={{ backgroundImage: `url(${VirtualRoot}${ImageSrc})` }}>{totalCount}</div>
                    </>
                );
            }
            else {
                return (
                    <div className={className} id={this.TagID}>
                        <div className="swiper-zoom-container">
                            <img src={VirtualRoot + ImageSrc} alt="상품사진" />
                        </div>
                        {totalCount}
                    </div>
                )
            }
            
        }
        else if (ImageSrc !== "" && Uid !== "" && Goods_No !== "" && Edit_Yn === "") {
            let renderBookMark = this.renderBookMark(Uid, Goods_No, Bookmark_Yn);
            let SoldOutrenderB = this.SoldOutrenderB()
            return (
                <>
                    <div className={className} id={this.TagID} style={{ backgroundImage: `url(${VirtualRoot}${ImageSrc})` }}>
                        {renderBookMark}
                        {SoldOutrenderB}
                        {this.AIimagerender()}
                    </div>
                </>
            );
        }
        else if (Edit_Yn !== "" && Uid !== "" && Goods_No !== "") {
            let renderEditFolder = this.renderEditFolder(Uid, Goods_No);
            let SoldOutrenderB = this.SoldOutrenderB()
            return (
                <>
                    <div className={className} id={this.TagID} style={{ backgroundImage: `url(${VirtualRoot}${ImageSrc})` }}>
                        {renderEditFolder}
                        {SoldOutrenderB}
                        {this.AIimagerender()}
                    </div>
                </>
            );
        }
        else if (ImageSrc !== "")
        {
            let SoldOutrender = this.SoldOutrenderA();
            return (
                <>
                    <div className={className} id={this.TagID} style={{ backgroundImage: `url(${VirtualRoot}${ImageSrc})` }}>
                        {SoldOutrender}
                    </div>
                </>
            );
        }
        
        else {
            return (
                <>
                    <div className={className} id={this.TagID}></div>
                </>
            );
        }
        
    }
}
